function createEmptyProcessos () {
  return {
    processos: [],
    processo: {
      cadastro: {
        cadastrante: {
          pessoa: {
            email: null,
            endereco: {
              bairro: null,
              cep: null,
              complemento: null,
              logradouro: null,
              municipio: {
                id: null,
                nome: null,
                nomeEstado: null
              },
              numero: null,
              semNumero: false,
              pessoaFisica: {
                cpf: null,
                nome: null,
                nomeEstadoCivil: null,
                nomeOrgaoExpedidor: null,
                rg: null
              }
            },
            enderecoCorrespondencia: {
              bairro: null,
              cep: null,
              complemento: null,
              logradouro: null,
              municipio: {
                id: null,
                nome: null,
                nomeEstado: null
              },
              numero: null,
              semNumero: false
            },
            telefones: [],
            tipo: true
          }
        },
        interessado: {
          conjuge: {
            pessoaFisica: {
              cpf: null,
              nome: null,
              nomeGentilico: null,
              naturalidade: null,
              nomeOrgaoExpedidor: null,
              rg: null
            }
          },
          pessoa: {
            email: null,
            endereco: {
              bairro: null,
              cep: null,
              complemento: null,
              logradouro: null,
              municipio: {
                id: null,
                nome: null,
                nomeEstado: null
              },
              numero: null,
              semNumero: false
            },

            pessoaFisica: {
              cpf: null,
              nome: null,
              nomeEstadoCivil: null,
              nomeGentilico: null,
              nomeOrgaoExpedidor: null,
              rg: null
            },
            pessoaJuridica: null,
            telefones: [],
            tipo: true
          }
        },
        imovel: {
          area: 0,
          descricaoAcesso: null,
          municipio: {
            id: null,
            nome: null,
            nomeEstado: null
          },
          nome: null,
          numeroReciboCar: null,
          possuiCar: true
        }
      }
    }
  }
}

function createEmptyDeclaracao () {
  return {
    numeroProcesso: null,
    motivoDeclaracao: {
      id: null
    },
    outroMotivo: null
  }
}

function createEmptyMensagens () {
  return {
    mensagensProcesso: []
  }
}

function createEmptyConversas () {
  return {
    tipo: null,
    tipoDocumentosAnexo: [],
    mensagens: {
      idxUltimaMensagem: 0,
      mensagemList: [
        {
          remetente: {
            id: 0
          }
        }
      ]
    },
    resposta: {
      anexoList: [],
      conteudo: null,
      remetente: {
        id: 0
      },
      destinatario: {
        id: 0
      },
      conversa: {
        id: 0
      }
    },
    conversasProcesso: {
      list: [],
      totalConversas: 0
    }
  }
}

function createEmptyPermuta () {
  return {
    id: null,
    finalizado: false,
    tipo: null,
    isAceiteTermoDeCompromisso: false,
    qualificacao: {
      pertenceAoProjeto: null,
      beneficiarioOriginal: null,
      pagoIntegral: null,
      gleba: {
        id: null,
        nome: null
      }
    },
    cadastrante: {
      id: null,
      pessoa: {
        id: null,
        email: null,
        telefones: [],
        tipo: true,
        pessoaJuridica: {
          id: null,
          razaoSocial: null,
          cnpj: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          dataNascimento: null,
          estadoCivil: null,
          possuiCertidaoObito: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      }
    },
    interessado: {
      id: null,
      espolio: null,
      documentos: [],
      sociosRepresentantesLegais: [],
      pessoa: {
        id: null,
        email: null,
        telefones: [],
        tipo: 'PF',
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null
        },
        pessoaJuridica: {
          id: null,
          cnpj: null,
          razaoSocial: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      },
      conjuge: {
        id: null,
        tipo: 'PF',
        email: null,
        telefones: [],
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          possuiCertidaoObito: null
        }
      }
    },
    imovel: {
      possuiCar: null,
      numeroReciboCar: null,
      numeroTitulo: null,
      tempoOcupacao: null,
      ocupantesAnteriores: null,
      possuiImovel: null,
      conflitos: null,
      causasImpossibilidadeOcupacao: null,
      numeroProcessoJudicial: null
    },
    georreferenciamento: {
      localizacoes: [],
      documentos: []
    }
  }
}

function createEmptyAforamento () {
  return {
    id: null,
    finalizado: false,
    tipo: null,
    isAceiteTermoDeCompromisso: false,
    cadastrante: {
      id: null,
      pessoa: {
        id: null,
        email: null,
        telefones: [],
        tipo: true,
        pessoaJuridica: {
          id: null,
          razaoSocial: null,
          cnpj: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          dataNascimento: null,
          possuiCertidaoObito: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      }
    },
    interessado: {
      id: null,
      socio: {
        documentos: []
      },
      espolio: null,
      sociosRepresentantesLegais: [],
      documentos: [],
      pessoa: {
        id: null,
        email: null,
        telefones: [],
        tipo: 'PF',
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null
        },
        pessoaJuridica: {
          id: null,
          cnpj: null,
          razaoSocial: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      },
      conjuge: {
        id: null,
        tipo: 'PF',
        email: null,
        telefones: [],
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          possuiCertidaoObito: null
        }
      }
    },
    imovel: {
      id: null,
      documentos: [],
      denominacao: null,
      area: 0,
      cnsMatricula: null,
      numeroMatricula: null,
      livroMatricula: null,
      numeroFolhaMatricula: null,
      nomeBeneficiarioTitulo: null,
      municipio: {
        id: null,
        nome: null,
        codigoEstado: null
      }
    },
    georreferenciamento: {
      id: null,
      documentos: [],
      localizacoes: []
    }
  }
}

function createEmptyTransferenciaDireito () {
  return {
    id: null,
    finalizado: false,
    tipo: null,
    isAceiteTermoDeCompromisso: false,
    cadastrante: {
      id: null,
      pessoa: {
        id: null,
        email: null,
        telefones: [],
        tipo: true,
        pessoaJuridica: {
          id: null,
          razaoSocial: null,
          cnpj: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          dataNascimento: null,
          possuiCertidaoObito: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      }
    },
    interessado: {
      id: null,
      socio: {
        documentos: []
      },
      espolio: null,
      sociosRepresentantesLegais: [],
      documentos: [],
      pessoa: {
        id: null,
        email: null,
        telefones: [],
        tipo: 'PF',
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null
        },
        pessoaJuridica: {
          id: null,
          cnpj: null,
          razaoSocial: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      },
      conjuge: {
        id: null,
        tipo: 'PF',
        email: null,
        telefones: [],
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          possuiCertidaoObito: null
        }
      }
    },
    imovel: {
      id: null,
      documentos: [],
      denominacao: null,
      area: 0,
      cnsMatricula: null,
      numeroMatricula: null,
      livroMatricula: null,
      numeroFolhaMatricula: null,
      nomeBeneficiarioTitulo: null,
      solicitarResgateAforamento: false,
      municipio: {
        id: null,
        nome: null,
        codigoEstado: null
      }
    },
    georreferenciamento: {
      id: null,
      documentos: [],
      localizacoes: []
    }
  }
}

function createEmptyFiltroProcessos () {
  return {
    numeroProcesso: '',
    cpfCnpj: '',
    nome: '',
    tipo: '',
    status: '',
    usuario: 0,
    parametro: '',
    pagina: 1,
    ordenacao: 'dataCadastro',
    tipoOrdenacao: 'desc',
    tipoPesquisa: 'SIMPLIFICADA'
  }
}

function createEmptySolicitarInformacoes () {
  return {
    id: null,
    finalizado: false,
    tipo: null,
    isAceiteTermoDeCompromisso: false,
    informacaoDesejada: {
      id: null,
      justificativa: null,
      tipoInformacao: null,
      outro: null
    },
    cadastrante: {
      id: null,
      pessoa: {
        id: null,
        email: null,
        telefones: [],
        tipo: true,
        pessoaJuridica: {
          id: null,
          razaoSocial: null,
          cnpj: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          dataNascimento: null,
          possuiCertidaoObito: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      }
    },
    interessado: {
      id: null,
      socio: {
        documentos: []
      },
      espolio: null,
      sociosRepresentantesLegais: [],
      documentos: [],
      pessoa: {
        id: null,
        email: null,
        telefones: [],
        tipo: 'PF',
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null
        },
        pessoaJuridica: {
          id: null,
          cnpj: null,
          razaoSocial: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      },
      conjuge: {
        id: null,
        tipo: 'PF',
        email: null,
        telefones: [],
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          possuiCertidaoObito: null
        }
      }
    },
    imovel: {
      id: null,
      documentos: [],
      denominacao: null,
      area: 0,
      nomeColonia: null,
      localizacao: null,
      municipio: {
        id: null,
        nome: null,
        codigoEstado: null
      },
      // matricula
      cnsMatricula: null,
      numeroMatricula: null,
      livroMatricula: null,
      numeroFolhaMatricula: null,
      // dados do titulo
      nomeBeneficiarioTitulo: null,
      numeroTitulo: null,
      areaTitulo: 0,
      dataExpedicaoTitulo: null,
      numeroLote: null,
      municipioTitulo: {
        id: null,
        nome: null,
        codigoEstado: null
      }
    }
  }
}

function createEmptyAreasPatrimoniais () {
  return {
    id: null,
    finalizado: false,
    tipo: null,
    isAceiteTermoDeCompromisso: false,
    solicitacao: {
      id: null,
      despacho: null,
      documentos: []
    },
    cadastrante: {
      id: null,
      pessoa: {
        id: null,
        email: null,
        telefones: [],
        tipo: 'PF',
        pessoaFisica: {
          id: null,
          nome: null,
          matricula: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          dataNascimento: null,
          possuiCertidaoObito: null
        },
        pessoaJuridica: {
          id: null,
          cnpj: null,
          razaoSocial: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      },
      documentos: []
    },
    interessado: {
      id: null,
      pessoa: {
        id: null,
        tipo: 'PJ',
        pessoaJuridica: {
          id: null,
          cnpj: null,
          razaoSocial: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      },
      prefeito: {
        id: null,
        isPrefeito: true,
        tipo: 'PF',
        email: null,
        telefones: [],
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      },
      documentos: []
    },
    georreferenciamento: {
      id: null,
      documentos: [],
      localizacoes: []
    }
  }
}

function createEmptyUsuarioCadastro () {
  return {
    usuariosCadastros: [],
    usuarioCadastroId: {
      idUsuario: null,
      idCadastro: null
    },
    protocolo: null
  }
}

function createEmptyLiberacaoClausulaResolutiva () {
  return {
    id: null,
    numeroProcesso: null,
    finalizado: false,
    tipo: null,
    isAceiteTermoDeCompromisso: false,
    solicitacao: {
      id: null,
      despacho: null,
      documentos: []
    },
    cadastrante: {
      id: null,
      pessoa: {
        id: null,
        email: null,
        telefones: [],
        tipo: 'PF',
        pessoaFisica: {
          id: null,
          nome: null,
          matricula: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          dataNascimento: null,
          possuiCertidaoObito: null
        },
        pessoaJuridica: {
          id: null,
          cnpj: null,
          razaoSocial: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      },
      documentos: []
    },
    interessado: {
      id: null,
      pessoa: {
        id: null,
        tipo: 'PJ',
        pessoaJuridica: {
          id: null,
          cnpj: null,
          razaoSocial: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      },
      prefeito: {
        id: null,
        isPrefeito: true,
        tipo: 'PF',
        email: null,
        telefones: [],
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null
        },
        endereco: {
          id: null,
          logradouro: null,
          semNumero: false,
          numero: null,
          complemento: null,
          bairro: null,
          cep: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          }
        }
      },
      documentos: []
    },
    imovel: {
      possuiCar: null,
      numeroReciboCar: null,
      numeroTitulo: null,
      tempoOcupacao: null,
      ocupantesAnteriores: null,
      possuiImovel: null,
      conflitos: null,
      causasImpossibilidadeOcupacao: null,
      numeroProcessoJudicial: null
    }
  }
}

const state = {
  emptyProcessos: createEmptyProcessos,
  emptyConversas: createEmptyConversas,
  emptyMensages: createEmptyMensagens,
  emptyPermuta: createEmptyPermuta,
  emptyAforamento: createEmptyAforamento,
  emptyFiltroProcessos: createEmptyFiltroProcessos,
  emptyDeclaracao: createEmptyDeclaracao,
  emptyTransferenciaDireito: createEmptyTransferenciaDireito,
  emptySolicitarInformacoes: createEmptySolicitarInformacoes,
  emptyAreasPatrimoniais: createEmptyAreasPatrimoniais,
  emptyUsuarioCadastro: createEmptyUsuarioCadastro,
  emptyLiberacaoClausulaResolutiva: createEmptyLiberacaoClausulaResolutiva
}

export default {
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/centralInteressado/empty.js